import themeVariables from "@/config/theme/themeVariable";
import { useFetchTags } from "../_hook";
import Link from "next/link";
import { useLanguage } from "@/hooks/useLanguage";

interface TagSidebarProps {
  className?: string;
}

export default function TagSidebar({ className = "" }: TagSidebarProps) {
  const { data: tags, loading } = useFetchTags();
  const { language } = useLanguage();

  if (loading) return null;

  return (
    <div className={`bg-white rounded-lg p-3 md:p-6 ${className}`}>
      {/* Topics Section */}
      <div className="mb-8">
        <h3 className="text-gray-900 font-semibold mb-4">태그</h3>
        <div className="flex flex-wrap gap-1.5">
          {tags?.result.map((topic: any) => (
            <Link href={`/${language}/blogs?tag=${topic.en}`} key={topic.en}>
              <span className={`${themeVariables.badge.light} cursor-pointer hover:bg-gray-200 transition-colors duration-150`}>
                {topic[language]}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
} 
